import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { UnitModel } from 'src/app/models/archive/unit.model';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UnitService {

  constructor(private _httpClient: HttpClient) { }

  createUnit(unitContractModel: UnitModel): Observable<UnitModel> {
    return this._httpClient.post<UnitModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.unit.CreateUnit}`,
      unitContractModel);
  }

  deleteUnit(unitId: number): Observable<UnitModel> {
    return this._httpClient.delete<UnitModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.unit.DeleteUnit}/${unitId}`);
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.unit.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getAllUnitsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.unit.GetAllUnitsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.unit.GetColumnsForGeneralConsultationAsync}`);
  }

  getInventoryUnits(): Observable<Array<UnitModel>> {
    return this._httpClient.get<Array<UnitModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.unit.GetInventoryUnits}`);
  }

  getRentalUnits(): Observable<Array<UnitModel>> {
    return this._httpClient.get<Array<UnitModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.unit.GetRentalUnits}`);
  }

  getUnitByCode(code: string): Observable<UnitModel> {
    const itemFilterResponse = new ItemFilterModel("code", null, null, "");
    itemFilterResponse.wildcard = code;
    return this._httpClient.post<UnitModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.unit.GetUnitByCode}`, itemFilterResponse);
  }

  getUnitById(unitId: number): Observable<UnitModel> {
    return this._httpClient.get<UnitModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.unit.GetUnitById}/${unitId}`);
  }

  updateUnit(unitContractModel: UnitModel): Observable<UnitModel> {
    return this._httpClient.put<UnitModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.unit.UpdateUnit}`,
      unitContractModel);
  }
}
